import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "loan-eligibility", emoji: "✅", title: "Loan Eligibility Calculator", desc: "Estimate the loan amount you may qualify for." };

function LoanEligibilityCalculator() {
  const [income, setIncome] = useState(80000);
  const [obligations, setObligations] = useState(10000);
  const [rate, setRate] = useState(8.5);
  const [years, setYears] = useState(20);
  const [foir, setFoir] = useState(50);

  // Lenders allow EMIs up to FOIR% of income, minus existing obligations.
  const affordableEMI = Math.max((income * foir) / 100 - obligations, 0);
  const r = rate / 100 / 12;
  const n = years * 12;
  // Reverse the EMI formula to find principal.
  const eligible = r > 0 ? (affordableEMI * (Math.pow(1 + r, n) - 1)) / (r * Math.pow(1 + r, n)) : affordableEMI * n;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>FOIR</strong> (Fixed Obligation to Income Ratio) is the share of
          income lenders let you spend on EMIs typically 40–55%. This is an
          estimate; actual eligibility depends on credit score and lender policy.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Net monthly income (₹)" value={income} onChange={setIncome} min={15000} max={1000000} step={5000} prefix="₹" />
          <CalcField label="Existing EMIs / obligations (₹)" value={obligations} onChange={setObligations} min={0} max={500000} step={1000} prefix="₹" />
          <CalcField label="Interest rate (% p.a.)" value={rate} onChange={setRate} min={6} max={20} step={0.1} suffix="%" />
          <CalcField label="Loan tenure (years)" value={years} onChange={setYears} min={1} max={30} suffix="yr" />
          <CalcField label="FOIR (% of income for EMI)" value={foir} onChange={setFoir} min={30} max={70} suffix="%" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>You may be eligible for</div>
            <div className="big">{formatINR(eligible)}</div>
          </div>
          <Row className="g-3">
            <Col xs={12}>
              <div className="fi-stat">
                <div className="num">{formatINR(affordableEMI)}</div>
                <small className="text-muted">Affordable monthly EMI</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default LoanEligibilityCalculator;
